import { Paragraph } from "@sikt/sds-core";
import clsx from "clsx";
import type { CSSProperties } from "react";
import type { VoteMode } from "../../shared/types";
import styles from "./ResultsChart.module.css";

interface ResultsChartProps {
  options: string[];
  counts: number[];
  mode: VoteMode;
}

export function ResultsChart({ options, counts, mode }: ResultsChartProps) {
  const max = Math.max(1, ...counts);
  const total = counts.reduce((sum, n) => sum + n, 0);
  const unit = mode === "dots" ? "stemmer" : "svar";

  if (total === 0) {
    return (
      <Paragraph color="secondary">
        Ingen svar ennå. Del stemmelenken med deltakerne – resultatene dukker
        opp her i det øyeblikket de svarer.
      </Paragraph>
    );
  }

  return (
    <ol className={styles.chart}>
      {options.map((option, index) => {
        const count = counts[index] ?? 0;
        const percent = total > 0 ? Math.round((count / total) * 100) : 0;
        return (
          <li key={index} className={styles.row}>
            <span className={styles.label}>{option}</span>
            <span className={styles.track}>
              <span
                className={styles.bar}
                data-category={(index % 8) + 1}
                data-empty={count === 0}
                style={{ "--fraction": count / max } as CSSProperties}
              />
            </span>
            <span
              className={clsx(styles.count, "sds-typography--tabular-nums")}
              aria-label={`${count} ${unit} (${percent} prosent)`}
            >
              {count}
              <span className={styles.percent} aria-hidden="true">
                {percent} %
              </span>
            </span>
          </li>
        );
      })}
    </ol>
  );
}
